<template>
    <div></div>
</template>
<script>
export default {
    name: "Add",
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>
<style></style>
